import { isAllowedForRegion } from "../actions/utils";

export const isEuRegion = !isAllowedForRegion

export const isCognitoAuth = () => isEuRegion
